import { optionsFunction } from "./_config";
import axios from "axios";

export const listAchievements = () =>
  axios.get(`api/achievements/list`, optionsFunction());

export const listTrophies = () =>
  axios.get(`api/trophies/list`, optionsFunction());
